import { FC } from 'react';
import { Container, ContainerProps } from '@mantine/core';

import classes from './FilterResultsSection.module.scss';

interface FilterResultsSectionProps extends ContainerProps {
  children: React.ReactNode;
  withNav?: boolean;
}

const FilterResultsSection: FC<FilterResultsSectionProps> = ({
  children,
  ...props
}) => {
  return (
    <Container
      fluid
      p={0}
      pb={{ md: 'lg', base: 'md' }}
      className={classes.filterResultsSection}
      pos={{ md: 'sticky' }}
      h={{
        sm: `calc(100vh - 9.125rem)`,
        base: `calc(100dvh - 8rem)`,
      }}
      {...props}
    >
      {children}
    </Container>
  );
};

export default FilterResultsSection;
